export enum OrderMode {
	INSIDE = 'inside',
	TAKE_AWAY = 'take_away',
	DELIVERY = 'delivery',
	PARK_COLLECT = 'parkCollect',
}

export enum OrderModeInArticle {
	INSIDE = 'inside',
	TAKE_AWAY = 'takeAway',
	DELIVERY = 'delivery',
	PARK_COLLECT = 'parkCollect',
}

export enum OrderModePrices {
	INSIDE = 'inside',
	TAKE_AWAY = 'takeAway',
	DELIVERY = 'delivery',
	BASE_INSIDE = 'baseInside',
	BASE_TAKE_AWAY = 'baseTakeAway',
	BASE_DELIVERY = 'baseDelivery',
}
